import { keyCodes } from './constants';

// eslint-disable-next-line import/prefer-default-export
export class RovingTabindex {
  constructor(
    elems,
    config = {
      direction: 'horizontal',
    }
  ) {
    this.elems = elems;
    this.config = config;

    this.isActive = false;

    this.onKeydown = this.onKeydown.bind(this);
  }

  init() {
    document.addEventListener('keydown', this.onKeydown);
    this.isActive = true;
  }

  destroy() {
    document.removeEventListener('keydown', this.onKeydown);
    this.isActive = false;
  }

  update(elems) {
    this.elems = elems;
  }

  onKeydown(e) {
    const activeElemIndex = this.elems.indexOf(document.activeElement);

    if (
      (e.which === keyCodes.ARROWUP || e.which === keyCodes.ARROWDOWN) &&
      this.config.direction === 'horizontal'
    ) {
      return;
    }

    if (
      (e.which === keyCodes.ARROWLEFT || e.which === keyCodes.ARROWRIGHT) &&
      this.config.direction === 'vertical'
    ) {
      return;
    }

    if (e.which === keyCodes.ARROWDOWN || e.which === keyCodes.ARROWRIGHT) {
      e.preventDefault();
      if (activeElemIndex >= 0 && activeElemIndex < this.elems.length - 1) {
        this.elems[activeElemIndex + 1].focus();
      } else {
        this.elems[0].focus();
      }
    }

    if (e.which === keyCodes.ARROWUP || e.which === keyCodes.ARROWLEFT) {
      e.preventDefault();
      if (activeElemIndex >= 1) {
        this.elems[activeElemIndex - 1].focus();
      } else {
        this.elems[this.elems.length - 1].focus();
      }
    }

    if (e.which === keyCodes.TAB) {
      this.destroy();
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/keyboard.js